














































































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {checkPermission} from '@/ts/helpers';
import {deleteRestaurant} from '@/ts/restaurants/delete-restaurant';
import {getRestaurants} from '@/ts/restaurants/get-restaurants';
import {postDonation} from '@/ts/donations/post-donation';

export default {
    name: 'TheTableRestaurants',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        fire(id) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteRestaurant(id).then(() => {
                        this.$swal.fire(
                            'Изтриването успешно!',
                            '',
                            'success',
                        );
                        const index = this.$store.state.response.response.findIndex((item) => item.id === id);
                        this.$store.state.response.response.splice(index, index);
                    });
                }
            });
        },
        donate(id) {
            postDonation(id).then(() => {
                this.$swal.fire(
                    'Изпратено успешно!',
                    'Заявката за дарение е изпратена успешно.',
                    'success',
                );
            });
        },
        sort(temp) {
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            this.$store.dispatch('setLoadingOn');
            getRestaurants().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        permission(name) {
            return checkPermission(name);
        },
    },
};
